import type { FaireProductEntity } from "../../entity_types/product";

export const p_3m2mhqwub9: FaireProductEntity = {
  token: "p_3m2mhqwub9",
  type: "product",
  name: "First 100 Words: A Padded Board Book",
  brandToken: "b_5ii3peotq1",
  brandName: "Macmillan Publishers",
  imageUrl:
    "https://cdn.faire.com/fastly/ea1cd60093bf0c915819f75ad7cc64bf1aa97918008c3e740456104ef73fee68.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.76,
  description:
    "Padded board book introducing 100 essential first words and pictures\n\n\nPUB DATE: 40673\nAuthor: PRIDDY, ROGER\nMEDIUM: BOARD BOOKS\nIllustrator:  \nImprint : Priddy Books",
  tags: [],
  msrpDollars: 5.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:03.078Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
